export default __webpack_public_path__ + "static/media/vacuum.ee19fc58.svg";